"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellEditor = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const column_1 = require("../column");
const INPUT_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
let CellEditor = class CellEditor extends vue_1.default {
    internalValue;
    value;
    col;
    row;
    globs;
    messages;
    validationState;
    autofocus;
    formId;
    onValueChanged(value) {
        this.internalValue = value;
    }
    focus() {
        const target = this.findFirstVisibleChildInput(this.$el);
        if (target) {
            target.focus();
        }
    }
    select() {
        const target = this.findFirstVisibleChildInput(this.$el);
        if (target && target.select) {
            target.select();
        }
    }
    findFirstVisibleChildInput(element) {
        if (INPUT_TAGS.indexOf(element.tagName) > -1 &&
            this.isVisible(element)) {
            return element;
        }
        for (let i = 0; i < element.children.length; i++) {
            let result = this.findFirstVisibleChildInput(element.children[i]);
            if (result) {
                return result;
            }
        }
    }
    isVisible(element) {
        const iel = element;
        if (iel.hidden) {
            return false;
        }
        return element.offsetWidth > 0 || element.offsetHeight > 0;
    }
    get currentValue() {
        return this.internalValue;
    }
    set currentValue(value) {
        this.$emit('update:value', value);
        this.internalValue = value;
    }
    get isDisabled() {
        return this.col.cellEditorIsDisabled
            ? this.col.cellEditorIsDisabled(this.row)
            : false;
    }
    data() {
        return {
            internalValue: this.value
        };
    }
    onChange() {
        this.col.emit(`${this.col.name}:change`, {
            col: this.col,
            row: this.row,
            field: this.col.name,
            value: this.internalValue
        });
    }
    onFieldChange(field, value) {
        this.col.owner.callListeners(`${field}:change`, {
            col: this.col.owner.columns,
            field,
            value
        });
    }
};
exports.CellEditor = CellEditor;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], CellEditor.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", column_1.ColumnDefinition)
], CellEditor.prototype, "col", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], CellEditor.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], CellEditor.prototype, "globs", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], CellEditor.prototype, "messages", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], CellEditor.prototype, "validationState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], CellEditor.prototype, "autofocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], CellEditor.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CellEditor.prototype, "onValueChanged", null);
exports.CellEditor = CellEditor = __decorate([
    vue_property_decorator_1.Component
], CellEditor);
//# sourceMappingURL=cell-editor.js.map